import React, { useState } from 'react';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'premium'>('premium');
  const packs = {
    basic: {
      id: 'basic',
      icon: '📘',
      title: 'PACK CI 6×6',
      subtitle: '6 Tomos + 4 Bonos',
      ideal: 'Todas las etapas · 35m² → 95m²',
      oldPrice: '$41.100',
      price: '$19.990',
      url: 'https://checkout.zentralpro.store/cart/44025490112548:1',
      ctaText: '→ ACCEDER AHORA'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      badge: '⭐ MÁS VENDIDO',
      title: 'PACK CI 6×6 + GESTIÓN',
      subtitle: 'Todo el 6×6 + Acelerador + Director de Obra',
      ideal: 'Controlar contratos, tiempos y costos como un profesional',
      oldPrice: '$75.000',
      price: '$27.990',
      url: 'https://checkout.zentralpro.store/cart/44025493553188:1',
      ctaText: '→ ACCEDER AHORA — PACK + GESTIÓN'
    }
  };
  const selected = packs[selectedPack];
  return <div id="precios" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
      <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border border-beige-dark" data-id="element-235">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-10 text-charcoal" data-id="element-236">
          Elegí tu Pack CI 6×6
        </h2>

        <div className="space-y-4 mb-10" data-id="element-237">
          {/* Basic Pack Card */}
          <div onClick={() => setSelectedPack('basic')} className={`relative rounded-2xl p-5 md:p-6 cursor-pointer transition-all border-2 flex items-center gap-4 md:gap-6 ${selectedPack === 'basic' ? 'border-gold bg-gold/5' : 'border-beige-dark hover:border-gray-300 bg-transparent'}`} data-id="element-238">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-gold' : 'border-gray-300'}`} data-id="element-239">
              {selectedPack === 'basic' && <div className="w-3 h-3 rounded-full bg-gold" data-id="element-240" />}
            </div>

            <div className="flex-grow flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-241">
              <div className="flex-1" data-id="element-242">
                <div className="text-2xl mb-2" data-id="element-243">{packs.basic.icon}</div>
                <h3 className="text-xl font-bold text-charcoal leading-tight" data-id="element-244">
                  {packs.basic.title}
                </h3>
                <p className="text-base text-gray-600 mt-1" data-id="element-245">
                  {packs.basic.subtitle}
                </p>
                <p className="text-sm text-gold mt-2 font-medium" data-id="element-246">
                  Ideal para: {packs.basic.ideal}
                </p>
              </div>
              <div className="text-left sm:text-right flex-shrink-0 flex flex-col justify-center" data-id="element-247">
                <div className="text-gray-400 line-through text-sm mb-1 font-medium" data-id="element-248">
                  {packs.basic.oldPrice}
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gold" data-id="element-249">
                  {packs.basic.price}
                </div>
              </div>
            </div>
          </div>

          {/* Premium Pack Card */}
          <div onClick={() => setSelectedPack('premium')} className={`relative rounded-2xl p-5 md:p-6 cursor-pointer transition-all border-2 flex items-center gap-4 md:gap-6 ${selectedPack === 'premium' ? 'border-gold bg-gold/5' : 'border-beige-dark hover:border-gray-300 bg-transparent'}`} data-id="element-250">
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 'premium' ? 'border-gold' : 'border-gray-300'}`} data-id="element-251">
              {selectedPack === 'premium' && <div className="w-3 h-3 rounded-full bg-gold" data-id="element-252" />}
            </div>

            <div className="flex-grow flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-253">
              <div className="flex-1" data-id="element-254">
                <div className="text-2xl mb-2 flex items-center gap-2" data-id="element-255">
                  {packs.premium.icon}
                  <span className="text-sm font-bold bg-gold/15 text-gold px-3 py-1 rounded-full uppercase tracking-wider border border-gold/30" data-id="element-256">
                    {packs.premium.badge}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-charcoal leading-tight" data-id="element-257">
                  {packs.premium.title}
                </h3>
                <p className="text-base text-gray-600 mt-1" data-id="element-258">
                  {packs.premium.subtitle}
                </p>
                <p className="text-sm text-gold mt-2 font-medium" data-id="element-259">
                  Ideal para: {packs.premium.ideal}
                </p>
              </div>
              <div className="text-left sm:text-right flex-shrink-0 flex flex-col justify-center" data-id="element-260">
                <div className="text-gray-400 line-through text-sm mb-1 font-medium" data-id="element-261">
                  {packs.premium.oldPrice}
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gold" data-id="element-262">
                  {packs.premium.price}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mb-6" data-id="element-263">
          <div className="bg-[#2C1A0E] text-white text-sm font-medium px-6 py-2 rounded-full inline-flex items-center gap-2 shadow-inner" data-id="element-264">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-265"></span>
            Oferta válida por tiempo limitado
          </div>
        </div>

        <a href={selected.url} target="_blank" rel="noopener noreferrer" className="block w-full bg-terracotta hover:bg-terracotta-light text-white text-center font-bold py-5 px-6 rounded shadow-md hover:shadow-lg transition-all text-xl" data-id="element-266">
          {selected.ctaText}
        </a>
      </div>
    </div>;
}